import React from "react";
import WalletCharge from "./WalletCharge";
import UserWalletInvoicesTable from "../admin/UserProfileTables/UserWalletInvoicesTable";
import UserWalletRecords from "../admin/UserProfileTables/UserWalletRecords";
import { isChargeInsertAuto } from "../../services/defaultSettings";
import Button from "../../components/ui/Button";
import { useLanguage } from "../../context/LanguageContext";

const UserWallet = () => {
    const { language } = useLanguage();

    const content = {
        or: { en: "Or:", ar: "أو :", de: "Oder:" },
        chargeCenter: {
            en: "Charge  Code",
            ar: "شحن كود",
            de: "Lade Code auf",
        },
        chargeInfo: {
            en: "Click this if you have purchased a code and need to charge it.",
            ar: "دي بتدوس عليها لو انت اشتريت كود و هتشحنه",
            de: "Klicken Sie hier, wenn Sie einen Code und ihn aufladen müssen.",
        },
    };

    return (
        <div className="flex flex-col space-y-8">
            <WalletCharge />
            {isChargeInsertAuto ? (
                <div className="flex-center-both space-y-2 flex-col">
                    <div className="flex-center-both space-x-2 space-x-reverse">
                        <span className="font-w-bold font-h3">{content.or[language]}</span>
                        <Button element="Link" to="/me/user/charge_insert_auto" color="blue">
                            {content.chargeCenter[language]}
                        </Button>
                    </div>
                    <div>
                        <div>{content.chargeInfo[language]}</div>
                    </div>
                </div>
            ) : (
                ""
            )}
            <UserWalletInvoicesTable />
            <UserWalletRecords />
        </div>
    );
};

export default UserWallet;
